import Vue from "vue";
import Vuex, { ActionContext, ActionTree } from "vuex";
import createPersistedState from "vuex-persistedstate";
import applicatif from "./applicatif";
import cds from "./cds";
import minuteur from "./minuteur";
import { IRacineState } from "./models";
import trainProgression from "./trainProgression";
import utilisateur from "./utilisateur";

Vue.use(Vuex);

interface IActions {
  effacerState: (context: ActionContext<IRacineState, IRacineState>) => void;
}

export const actions: IActions & ActionTree<IRacineState, IRacineState> = {
  effacerState: (context) => {
    context.commit(modules.cds.mutations.effacerStateCDS.name);
    context.commit(modules.minuteur.mutations.effacerStateMinuteur.name);
    context.commit(
      modules.trainProgression.mutations.effacerStateTrainProgression.name
    );
    context.commit(modules.utilisateur.mutations.effacerStateUtilisateur.name);
  },
};

export const modules = {
  utilisateur,
  cds,
  trainProgression,
  minuteur,
  applicatif,
};
const debug = process.env.NODE_ENV !== "production";

export const store = new Vuex.Store<IRacineState>({
  actions,
  modules,
  plugins: [createPersistedState()],
  strict: debug,
});

export default store;
